import { useState } from 'react';

const useUserPageState = () => {
    const [userInfo, setUserInfo] = useState();

    const setSecurityProfile = (securityProfileIds, instance) => {
        const newInstanceArray = userInfo.instances.reduce((acc, curr) => {
            if (curr.instanceid === instance.instanceid) {
                return [
                    ...acc,
                    {
                        ...curr,
                        user: {
                            ...curr.user,
                            SecurityProfileIds: securityProfileIds.map((s) => s.value),
                        },
                    },
                ];
            }
            return [...acc, curr];
        }, []);
        const newUserObject = { ...userInfo, instances: newInstanceArray };
        setUserInfo(newUserObject);
    };

    const setRoutingProfile = (routingProfileId, instance) => {
        const newInstanceArray = userInfo.instances.reduce((acc, curr) => {
            if (curr.instanceid === instance.instanceid) {
                return [
                    ...acc,
                    { ...curr, user: { ...curr.user, RoutingProfileId: routingProfileId } },
                ];
            }
            return [...acc, curr];
        }, []);
        const newUserObject = { ...userInfo, instances: newInstanceArray };
        setUserInfo(newUserObject);
    };

    const setSchedule = (scheduleid, instance) => {
        const newInstanceArray = userInfo.instances.reduce((acc, curr) => {
            if (curr.instanceid === instance.instanceid) {
                return [...acc, { ...curr, scheduleid: scheduleid ? scheduleid : undefined }];
            }
            return [...acc, curr];
        }, []);
        const newUserObject = { ...userInfo, instances: newInstanceArray };
        setUserInfo(newUserObject);
    };

    const setAutoAccept = (bool, instance) => {
        const newInstanceArray = userInfo.instances.reduce((acc, curr) => {
            if (curr.instanceid === instance.instanceid) {
                return [
                    ...acc,
                    {
                        ...curr,
                        user: {
                            ...curr.user,
                            PhoneConfig: { ...curr.user.PhoneConfig, AutoAccept: bool },
                        },
                    },
                ];
            }
            return [...acc, curr];
        }, []);
        const newUserObject = { ...userInfo, instances: newInstanceArray };
        setUserInfo(newUserObject);
    };

    const setAfterCallAllowance = (value, instance) => {
        const newInstanceArray = userInfo.instances.reduce((acc, curr) => {
            if (curr.instanceid === instance.instanceid) {
                return [
                    ...acc,
                    {
                        ...curr,
                        user: {
                            ...curr.user,
                            PhoneConfig: {
                                ...curr.user.PhoneConfig,
                                AfterContactWorkTimeLimit: parseInt(value),
                            },
                        },
                    },
                ];
            }
            return [...acc, curr];
        }, []);
        const newUserObject = { ...userInfo, instances: newInstanceArray };
        setUserInfo(newUserObject);
    };

    const setPermission = (id, event) => {
        const { target } = event;

        if (target.checked) {
            const permissionAdded = [...userInfo.permissions, { id }];
            setUserInfo({ ...userInfo, permissions: permissionAdded });
        } else {
            const permissionRemoved = userInfo.permissions.filter((p) => p.id !== id);
            setUserInfo({ ...userInfo, permissions: permissionRemoved });
        }
    };

    const addInstance = (id, user) => {
        const newInstanceArray = userInfo.instances;
        newInstanceArray.forEach((instance) => {
            if (instance.instanceid === id) {
                instance.user = user;
            }
        });
        const newUserObject = { ...userInfo, instances: newInstanceArray };
        setUserInfo(newUserObject);
    };

    const removeInstance = (id) => {
        const newInstanceArray = userInfo.instances;
        newInstanceArray.forEach((instance) => {
            if (instance.instanceid === id) {
                instance.user = undefined;
            }
        });
        const newUserObject = { ...userInfo, instances: newInstanceArray };
        setUserInfo(newUserObject);
    };

    const parseName = (value) => {
        const parts = (value || '').split(' ');
        const newFirstName = parts[0];
        parts.shift();
        const newSurname = parts.join(' ');
        setUserInfo({ ...userInfo, firstname: newFirstName, surname: newSurname });
    };

    return {
        userInfo,
        setUserInfo,
        setRoutingProfile,
        setSecurityProfile,
        setSchedule,
        setAutoAccept,
        setAfterCallAllowance,
        setPermission,
        parseName,
        removeInstance,
        addInstance,
    };
};

export default useUserPageState;
